/**
 * What a route shows while its own code is on the way.
 *
 * Every page is now fetched on demand (hardening P4 step 1), so between asking for a
 * page and seeing it there is a real gap — tens of milliseconds on an office
 * connection, longer on a phone.
 *
 * Where this actually paints: a **cold load** — the first page after a login, or a hard
 * reload straight onto a deep route. It does *not* paint when you click around inside
 * the app, and that is React Router v7 working as intended: the navigation runs in a
 * transition, so React keeps the page you are on until the next one is ready rather than
 * blanking it. Verified under an artificial 3-second chunk delay (iteration 760): the
 * sidebar highlight moves immediately, the old content stays, the new content swaps in
 * when it arrives. Comfortable at office speed; if slow-connection feedback is ever
 * wanted it needs a navigation progress bar, not this (backlogged).
 *
 * Deliberately plain: an empty area looks broken, and anything bigger than this looks
 * worse than the wait it is covering.
 *
 * `fullScreen` is for the routes that render without any chrome — login, the print views.
 */
export const RouteFallback = ({ fullScreen = false }) => (
  <div
    className={
      fullScreen
        ? 'min-h-screen bg-background flex items-center justify-center'
        : 'flex items-center justify-center py-24'
    }
    data-testid="route-loading"
  >
    <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" />
  </div>
);

export default RouteFallback;
